export default __webpack_public_path__ + "img/IPLTHgiT.ad75e282.svg";